import React from 'react';
import PropTypes from 'prop-types';
import {IntroSection, GamePlaySection, RecruitHeroes, DiscoverKingdom, MasterElements, ForgeStronghold, Carousel} from '../../components/newHome';
import {connectToStores} from 'epic-alt-utils/index';
import {HomeStore, LoginStore, AppConfigStore, SubscriptionStore} from '../../stores';


@connectToStores
export default class NewHomeView extends React.PureComponent {
    static propTypes = {
        homeStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        loginStore: PropTypes.object,
        subscriptionStore: PropTypes.object
    };

    static getStores() {
        return [HomeStore, LoginStore, AppConfigStore, SubscriptionStore];
    }

    static getPropsFromStores() {
        return {
            homeStore: HomeStore.getState(),
            loginStore: LoginStore.getState(),
            appConfigStore: AppConfigStore.getState(),
            subscriptionStore: SubscriptionStore.getState()
        };
    }

    render() {
        const {
            launchedCountries, unavailableCountries, isGameLaunched, isGameUnavailable, country
        } = this.props.appConfigStore;
        const introContent = this.props.homeStore.introSection;
        const {isLoggedIn} = this.props.loginStore;
        const {isSubscribed} = this.props.subscriptionStore;
        return (
            <div className="new-bb-home">
                <IntroSection
                    launchedCountries={launchedCountries}
                    unavailableCountries={unavailableCountries}
                    introContent={introContent}
                    isGameLaunched={isGameLaunched}
                    isGameUnavailable={isGameUnavailable}
                    isLoggedIn={isLoggedIn}
                    country={country}
                    isSubscribed={isSubscribed} />
                <GamePlaySection
                    content={introContent} />
                <RecruitHeroes />
                <DiscoverKingdom />
                <MasterElements />
                <ForgeStronghold />
                <Carousel
                    refFunction={(c) => {this.gallerySlider = c;}} />
                <Carousel
                    refFunction={(c) => {this.newsSlider = c;}}
                    news />
            </div>
        );
    }
}

